import React from "react";
import { ParallaxProvider } from "react-scroll-parallax";
import Navbar from './components/Navbar';
import UniverseSection from './components/Universe';
import FeaturesPage from './components/FeaturesPage';
import ProblemStatementSection from './components/ProblemStatementSection';
import SolutionSection from './components/SolutionSection';
import TestimonialsSection from './components/TestimonialsSection';
import Footer from './components/Footer';
import StarryNight from './components/StarryNight';
import './assets/styles/main.css';

function App() {
  return (
    <ParallaxProvider>
      <div>
        <StarryNight /> {/* Starry background */}
        <Navbar />
        <UniverseSection /> {/* This section has id="home" */}
        <ProblemStatementSection /> {/* Integrated Section */}
        <SolutionSection /> {/* Updated Section */}
        <FeaturesPage /> {/* Ensure this has id="features" */}
        <TestimonialsSection /> {/* Ensure this has id="testimonials" */}
        <Footer />
      </div>
    </ParallaxProvider>
  );
}

export default App;